import { Box } from '@hover/blueprint';
import React, { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import ToolDescription from './ToolDescription';

const CareersOurToolsDesktop: React.FC = () => {
  const [currentTool, setCurrentTool] = useState<number>(1);

  return (
    <Box d={{ base: 'none', desktop: 'flex' }}>
      <Box
        ml="110px"
        w="100%"
        position="sticky"
        top={0}
        d="flex"
        alignItems="center"
        justifyContent="center"
        h="100vh"
      >
        <Box
          opacity={currentTool === 1 ? 1 : 0}
          w={currentTool === 1 ? 'auto' : 0}
          transition="all 1s ease-in"
        >
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/careers_our_tools_1.png"
            alt="Growth, Learning, and Development"
          />
        </Box>
        <Box
          opacity={currentTool === 2 ? 1 : 0}
          w={currentTool === 2 ? 'auto' : 0}
          transition="all 1s ease-in"
        >
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/careers_our_tools_2.png"
            alt="Diversity and Inclusion"
          />
        </Box>
        <Box
          opacity={currentTool === 3 ? 1 : 0}
          w={currentTool === 3 ? 'auto' : 0}
          transition="all 1s ease-in"
        >
          <StaticImage
            quality={100}
            placeholder="blurred"
            src="../../../assets/images/careers_our_tools_3.png"
            alt="Wellness"
          />
        </Box>
      </Box>
      <Box w="100%" height="300vh" flexDir="column">
        <ToolDescription
          toolNumber={1}
          body="HOVER’s robust L&D program supports the greater culture of learning that exists
          at HOVER. Employees are given the tools and time to learn new skills, hear from industry
           experts, and advance in their careers. Employees personalize their growth with regular
           in-house offerings, dedicated time for self-directed learning, leadership coaching,
           generous per-employee funding for outside opportunities, and more."
          header="Growth, Learning, and Development"
          setCurrentTool={setCurrentTool}
        />
        <ToolDescription
          toolNumber={2}
          body="A diverse HOVER where employees experience true inclusion is good for employees and
          critical to our success. From recruitment practices that reduce the impact of systemic
          inequities to supporting the exemplary educational, policy, and community work of our
          employee-led D&I Committee, we are committed to addressing bias and fostering belonging at HOVER."
          header="Diversity and Inclusion"
          setCurrentTool={setCurrentTool}
        />
        <ToolDescription
          toolNumber={3}
          body="We believe in work/life balance. We offer flexible work policies and seek to build warm,
          collegial relationships with one another regardless of role or location. We have monthly “Self-Care
           Days,” a paid day off, and a competitive suite of Health & Wellness benefits to support employees
            and their families at all stages of life."
          header="Wellness"
          setCurrentTool={setCurrentTool}
        />
      </Box>
    </Box>
  );
};

export default CareersOurToolsDesktop;
